import React from "react";
import { connect } from "react-redux";
import { Button, Icon, Input, Row, Col, Modal, Form, Select } from 'antd';

import BraftEditor from 'braft-editor'
import 'braft-editor/dist/braft.css'

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
import {
	changeNotificationTemplate,
	selectNotificationTemplate,
	updateNotificationTemplate,
} from "../../actions/recruitment-actions";
import notificationTemplateService from "../../services/Recruitment/notification-template-service";
import uploadService from "../../services/Common/upload-service";

const templateTypeMap = ["请选择", "企业微信", "邮件", "短信"];

class NotificationTemplate extends ReduxComponent {

	initReload = true;
	moduleName = "recruitment";
	childModuleName = "notificationTemplate";

	state = {
		currentModalStatus: false,
		currentIndex: false,
		currentData: {},
		listTime:"开始时间：{{start_time}}； 结束时间：{{end_time}} ； 面试时间：{{arrange_inte_time}} ； 录用时间：{{entry_time}}； ",
		list:"培训名称：{{training_name}}； 面试轮次：{{interview_times}}； 面试职位：{{interview_position}}；",
		listName:"面试者姓名：{{interviewee_name}}； 姓名：{{username}}；"
	}

	actions = {
		changeAction: this.props.changeNotificationTemplate,
		selectAction: this.props.selectNotificationTemplate,
		updateAction: this.props.updateNotificationTemplate,

		deleteAction: notificationTemplateService.deleteNotificationTemplate,
		createAction: notificationTemplateService.createNotificationTemplate,
	}

  handleHTMLChange = html => this.setState({
  	htmlContent: html
  });

	setKeywordFilter = value => this.actions.changeAction({name: value}, "reload")

	changeKeywordFilter = event => {
		if (!event.target.value) {
			this.actions.changeAction({name: ""}, "reload")
		}
	}

	createData = () => this.setState({
		currentModalStatus: true,
		currentIndex: null,
		currentData: {
			content: "",
			description: "",
			name: "",
			temp_type: 1,
			temp_type_name: "企业微信"
		},
		templateType: 1		
	})

	updateData = (record, index) => this.setState({
		currentModalStatus: true,
		currentIndex: index,
		currentData: record,
		templateType: record.temp_type
	})

	editorUpload = param => {
		console.log(param);
		let formData = new FormData();
		formData.append("uploadedFile", param.file);
		uploadService.commonUpload(formData, res => {
			// console.log(res);
			param.success({
				url: res.data.Message
			});
		})
	}

// const uploadFn = (param) => {
//   const serverURL = 'http://upload-server'
//   const xhr = new XMLHttpRequest
//   const fd = new FormData()
//   // libraryId可用于通过mediaLibrary示例来操作对应的媒体内容
//   console.log(param.libraryId)
//   const successFn = (response) => {
//     // 假设服务端直接返回文件上传后的地址
//     // 上传成功后调用param.success并传入上传后的文件地址
//     param.success({
//       url: xhr.responseText
//     })
//   }
//   const progressFn = (event) => {
//     // 上传进度发生变化时调用param.progress
//     param.progress(event.loaded / event.total * 100)
//   }
//   const errorFn = (response) => {
//     // 上传发生错误时调用param.error
//     param.error({
//       msg: 'unable to upload.'
//     })
//   }
//   xhr.upload.addEventListener("progress", progressFn, false)
//   xhr.addEventListener("load", successFn, false)
//   xhr.addEventListener("error", errorFn, false)
//   xhr.addEventListener("abort", errorFn, false)
//   fd.append('file', param.file)
//   xhr.open('POST', serverURL, true)
//   xhr.send(fd)
// }

	publicSubmit = () => {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let currentData = {
					...this.state.currentData,
					...values,
					temp_type_name: templateTypeMap[values.temp_type],
					content: this.state.templateType === 2 ? this.state.htmlContent : values.content
				}
				let callee = null === this.state.currentIndex ? this.publicCreate : this.publicUpdate;
				callee(currentData);
			}
		})
	}

	column = [{
			title: '模版名称',
			dataIndex: 'name',
			key: 'name',
			className: 'table-global-head-short'
		},{
			title: '模版类型',
			dataIndex: 'temp_type_name',
			key: 'temp_type_name',
			className: 'table-global-head-short'
		}, {
			title: '用途',
			dataIndex: 'description',
			key: 'description',
			className: 'table-global-head-short'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head',
			render: (text, record, index) => {
				return (
					<span>
						{this.props.access.notificationTemplate.u_value && <Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.updateData.bind(this, record, index)}>编辑</Button>}
					</span>
				);
			} 
		}
	];

	render() {

    const editorProps = {
      height: 500,
      contentFormat: 'html',
      initialContent: this.state.currentData.content,
      onHTMLChange: this.handleHTMLChange,
      media: {
      	uploadFn: this.editorUpload
      }
    }

		return (
			<div className="app-module-item">
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="通知模版"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal.bind(this, false)}
					onOk={this.publicSubmit} >
					<div className="app-modal-item">
						{this.state.currentData && 
						<Form onSubmit={this.publicSubmit} className="login-form" layout="inline">
							
							<Row>
								<Col span={12}>
									<div style={{marginBottom:"15px"}}>
										<Form.Item label="模版名称">
											{this.props.form.getFieldDecorator('name', {
												rules: [{ required: true, message: '请输入模版名称' }],
												initialValue: this.state.currentData.name
											})(<Input style={{width:"300px"}} />)}
										</Form.Item>
									</div>
								</Col>
								<Col span={12}>
									<div style={{marginBottom:"15px"}}>
										<Form.Item label="模版类型">
											{this.props.form.getFieldDecorator('temp_type', {
												rules: [{ required: true, message: '请输入模版类型' }],
												initialValue: this.state.currentData.temp_type
											})(
												<Select style={{width:"300px"}}
													onSelect={value => this.setState({templateType: value})}>
													{templateTypeMap.map((type, index)=> {
														if (0 !== index) {
															return (<Select.Option key={index} 
																value={index}>{type}</Select.Option>
															)
														}
														return null;
													})}
												</Select>
											)}
										</Form.Item>
									</div>
								</Col>
								<Col span={12}>
									<div style={{marginBottom:"15px"}}>
										<Form.Item label="用途">
											{this.props.form.getFieldDecorator('description', {
												rules: [{ required: true, message: '请输入用途' }],
												initialValue: this.state.currentData.description
											})(<Input style={{width:"300px"}} />)}
										</Form.Item>
									</div>
								</Col>
							</Row>
							<Row>
								<Col span={24}>
									<div style={{textAlign:"left", paddingLeft:"80px", marginBottom:"20px"}}>
										<div>{this.state.listTime}</div>
										<div>{this.state.list}</div>
										<div>{this.state.listName}</div>
									</div>
								</Col>
							</Row>
							<Row>
								{this.state.templateType === 2 ?
								<Col span={24}>
									<div style={{marginBottom:"15px"}}>
									  <div className="demo">
							        <BraftEditor {...editorProps}/>
							      </div>
									</div>									
								</Col> :
								<Col span={24}>
									<div style={{marginBottom:"15px"}}>
										<Form.Item label="提醒内容">
											{this.props.form.getFieldDecorator('content', {
												rules: [{ required: true, message: '请输入提醒内容' }],
												initialValue: this.state.currentData.content
											})(<Input.TextArea rows={8} style={{width:"780px"}} />)}
										</Form.Item>
									</div>	
								</Col>}
							</Row>
						</Form>}
					</div>
				</Modal>
				<div style={{marginBottom: "20px"}}>
					{this.props.access.notificationTemplate.c_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.createData}>
							<Icon type="plus-circle-o" />
							<span>新增</span>
						</Button>
					</div>}
					{this.props.access.notificationTemplate.d_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete" />
							<span>批量删除</span>
						</Button>
					</div>}
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Input.Search
							placeholder="关键字"
							onSearch={this.setKeywordFilter}
							onChange={this.changeKeywordFilter}
							style={{ width: 200 }}
							defaultValue={this.props[this.moduleName][this.childModuleName].filters.keyword}
							enterButton />
					</div>
					<div style={{clear: "both"}}></div>
				</div>
				<div>{this.publicTableView()}</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		recruitment: state.recruitment
	}
}

const mapDispatchToProps = {
	changeNotificationTemplate,
	selectNotificationTemplate,
	updateNotificationTemplate,
}

NotificationTemplate = Form.create()(NotificationTemplate);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(NotificationTemplate));







// WEBPACK FOOTER //
// ./src/routes/Recruitment/NotificationTemplate.js